export enum DropdownIdentifier {
  Grade = "grades",
  Scheme = "schemes",
  Period = "periods"
}
